module.exports = __webpack_public_path__ + "img/NoData2.3079e09b.png";